// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoTip_wrapper__IFT0e","icon":"InfoTip_icon__++YiV","tooltip":"InfoTip_tooltip__kaCkb","alignEnd":"InfoTip_alignEnd__Hv2er"};